<template>
    <el-table :data="products" style="width: 100%">
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="name" label="应用名称"></el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column prop="type_name" label="产品类型"></el-table-column>
        <el-table-column prop="memo" label="简介"></el-table-column>
        <el-table-column prop="status_memo" label="上架状态"></el-table-column>
        <el-table-column prop="display" label="排序"></el-table-column>
        <el-table-column prop="created_at" label="添加时间"></el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope" >
                <div v-if="show">
                    <el-button @click="handleActive(scope.row)" v-show="Acs('/products/update')" type="text" size="small">激活</el-button>
                </div>
                <div v-else>
                    <el-button @click="handleEdit(scope.row)" v-show="Acs('/products/update')" type="text" size="small">编辑</el-button>
                    <el-button @click="handleDelete(scope.row.id)" v-show="Acs('/products/delete')" type="text" size="small">删除</el-button>
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
    export default {
        props: {
            show: {
                type: Boolean,
                required: false,
            },
            products: {
                type: Array,
                required: true
            }
        },
        methods: {
            handleEdit(data) {
                this.$emit('handleEdit', data);
            },

            handleDelete(id) {
                this.$emit('handleDel', id);
            },

            handleActive(data) {
                this.$emit('handleActive', data)
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/product/table.vue